import React, { useState, useEffect } from 'react';
import Post from '../../../utils/Post';
import VainillaDialog from '../../sharecomponents/vanilladialog';
import Verifiers from '../../../utils/Verifiers.jsx';
import LineaDeAvance from '../campo/NETJET/componentes/LineaDeAvance';
import ReporteSemillaPDF from '../../templates/ReporteSemillaPDF';

const ReporteSemilla = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [payload, setpayload] = useState({ semana_inicio: '', semana_fin: '', anio: '' });
    const [reporte, setreporte] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [reportePDF, setreportePDF] = useState(false);
    const classCompletos = 'text-bold text-green3 text-end';
    const classIncompletos = 'text-red3 text-end';
    const classHeader = 'text-center text-white bg-black';
    const classHeaderDetalles = 'text-center';
    const registro_completo = 'text-bold text-center opacity-50';
    const registro_incompleto = 'text-bold text-center';
    const buttonClass = 'bw-150 p-0 text-xs round-xxl border-2 border-warning shadow bg-light contenedor'
    useEffect(() => {
        getReporte();
    }, []);

    const getReporte = async (payl = { ...payload }) => {
        let resp = await Post('reportes/semillas/get', payl, 'POST', setloader);

        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Ocurrió un error', 'error');
            return;
        }
        setreporte([...resp.data.reporte]);
        setsemanas([...resp.data.semanas]);
        setpayload({ ...payl, semana_inicio: resp.data.semana_inicio, semana_fin: resp.data.semana_fin });
    }

    const selectorSemana = (tipo, title) => {
        return (
            <div className='form-group bw-200'>
                <label className='text-bold'>{title}</label>
                <select className='form-control form-control-sm shadow-sm round-s'
                    value={payload[tipo]}
                    onChange={(e) => getReporte({ ...payload, [tipo]: e.target.value })}>
                    {semanas.map((sem, i) => <option key={i + tipo} value={sem} >{sem}</option>)}
                </select>

            </div>
        );
    }

    const confirmarCompletarMultiples = (registro) => {
        setdialog({
            show: true,
            tipo: 'error',
            title: registro ?
                `¿Desea marcar como completos los ${extraerIdPlanesFaltantes(registro).length} registros faltantes de completar de este bloque?` :
                '¿Desea marcar como completados todos los registros de este reporte?',
            body: '', size: 'l',
            respYes: 'ACEPTAR',
            respNot: 'REGRESAR',
            funct: (resp) => {
                if (resp) {
                    completarMultiples(registro);
                }
                setdialog({ show: false });
            }
        });
    }

    /**
     * Completa un grupo de registros de reportes de semilla, si se envia el attributo registro se completa ese bloque en todas las semanas correspondientes, de lo contrario
     * se se completan todos los bloques del reporte.
     * @param {object|null} registro 
     */
    const completarMultiples = async (registro, loader = true) => {
        let ids = extraerIdPlanesFaltantes(registro);
        let payl = { ...payload, registros: ids };
        let resp = await Post('reportes/semillas/activar', payl, 'POST', loader ? setloader : null);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Ocurrió un error', 'error');
            return;
        }
        setreporte([...resp.data.reporte]);
        setsemanas([...resp.data.semanas]);

    }

    /**
     * Extrae los ids de los registros que no tienen nombre asignado, es decir, los registros que no han sido completados.
     * @param {list|null} registros 
     * @returns {array} lista de enteros
     */
    const extraerIdPlanesFaltantes = (registros) => {
        let ids = [];
        if (registros) {
            registros.forEach(reg => {
                if (!reg.nombre) {
                    ids.push(reg.id);
                }
            });
        } else {
            reporte.forEach(rep => {
                rep.registros.forEach(reg => {
                    if (!reg.nombre) {
                        ids.push(reg.id);
                    }
                });
            });
        }
        return ids;
    }

    /**
     * Cambia el estado de un registro de reporte de semilla, si el registro no se ha completado se marca como completado, de lo contrario se desmarca como completado.
     * @param {array} registro 
     * @returns 
     */
    const switchRegistro = async (registro) => {
        if (registro.completo === 'NO') {
            //Si el registro aún no se completa se usa la funcion para marcar completado
            await completarMultiples([registro], false);
            return;
        }
        //Si ya se completo usamos la APIpara desmarcarlo como completo
        let params = { ...payload, id: registro.reporte_semilla_id };
        let resp = await Post('reportes/semillas/desactivar', params, 'POST');
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Ocurrió un error', 'error');
            return;
        }
        setreporte([...resp.data.reporte]);
        setsemanas([...resp.data.semanas]);
    }

    const porcentajeAvance = (registro) => {
        let conteo = extraerTotales(registro);
        let total = conteo.completo + conteo.incompleto;
        if (total === 0) return 0;
        return Math.round((conteo.completo / total) * 100);
    }

    const extraerTotales = (registro) => {
        if (registro) {
            return {
                completo: registro.completo_semillas,
                incompleto: registro.incompletos_semillas
            }
        }
        let conteo = { completo: 0, incompleto: 0 }
        reporte.forEach(rep => {
            conteo.completo += rep.completo_semillas
            conteo.incompleto += rep.incompletos_semillas;
        });
        return conteo;
    }

    return (
        <div className='vw-100 p-1 m-0' >
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className=" p-2 bg-orange-900">
                    <p className="font-bold uppercase text-white h4">Reporte de semilla <span className="text-s text-300 text-white ms-3">Defina si se tiene la semilla necesaria</span></p>
                </div>
                {selectorSemana('semana_inicio', 'Semana de inicio')}
                {selectorSemana('semana_fin', 'Semana de fin')}
                <div className='bw-450 text-s contenedor'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-30 text-center text-m'>
                            <div className='text-bold text-xs w-100'>Avance total</div>
                            {porcentajeAvance()}%
                        </div>
                        <div className='w-35 text-center text-m'>
                            <div className='text-bold text-xs w-100'>Semilla completo</div>
                            {extraerTotales().completo.toLocaleString('en-US')}
                        </div>
                        <div className='w-35 text-center text-m'>
                            <div className='text-bold text-xs w-100'>Semilla faltante</div>
                            {extraerTotales().incompleto.toLocaleString('en-US')}
                        </div>
                    </div>
                </div>
                <div className='col-auto contenedor'>
                    <div className='bw-250 p-0 text-s round-xxl border-3 border-warning shadow bg-light pointer contenedor pon'
                        onClick={() => confirmarCompletarMultiples(null)}>
                        Completar todos los bloques
                    </div>
                </div>
                <div className='col-auto contenedor'>
                    <div className='bw-50 p-1 border round-m bg-red3 text-white text-bold shadow scale-025 pointer'
                        onClick={() => setreportePDF(true)}>PDF</div>
                </div>

                {reporte.length > 0 && <LineaDeAvance avance={porcentajeAvance()} />}

                <div className='w-100 p-1 pt-0 border-top border-bottom bg-light round-s shadow-sm mt-2' style={{ height: '75vh', overflow: 'auto' }}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {reporte.map((rep, i) => {
                            let total = rep.completo_semillas + rep.incompletos_semillas;
                            if (total === 0) total = 1;
                            let porcentaje = Math.round((rep.completo_semillas / total) * 100);
                            return (<>
                                <div className='bw-1200 round-s shadow bg-white mt-1 pt-1 pb-1 contenedor' key={i + "rep"}>
                                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                                        <div className='bw-400 teext-bold'>
                                            {rep.bloque}
                                        </div>
                                        <div className='bw-150 teext-bold text-xs'>
                                            Faltante:<span className='text-bold ps-1 text-s text-red3'>{rep.incompletos_semillas.toLocaleString('en-US')}</span>
                                        </div>
                                        <div className='bw-150 teext-bold text-xs'>
                                            Completo:<span className='text-bold text-s ps-1 text-green3'>{rep.completo_semillas.toLocaleString('en-US')}</span>
                                        </div>
                                        <div className='bw-150 teext-bold text-xs'>
                                            avance:<span className='text-bold text-s ps-13'>{porcentaje}%</span>
                                        </div>
                                        <div className={buttonClass + (rep.incompletos_semillas == 0 ? ' opacity-50' : ' pointer scale-025')}
                                            onClick={() => {
                                                if (rep.incompletos_semillas === 0) return;
                                                confirmarCompletarMultiples(rep.registros)
                                            }}
                                        >
                                            Completar bloque
                                        </div>
                                        <div className='col-auto'>

                                        </div>
                                        <div className='w-100 mt-1 mb-2'>
                                            <div className='row justify-content-start w-100 m-0 p-0'>
                                                <div className='w-80 border-bottom' />
                                            </div>
                                        </div>

                                        {
                                            rep.registros.map((reg, j) =>
                                                <div className={'bw-800 border-bottom mt-1 pb-1 contenedor ' + (reg.nombre ? ' text-green4' : ' text-red4')} key={reg.id + " " + j + " " + i}>
                                                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                                                        <div className='bw-150 text-xs me-2 opacity-70'>
                                                            Semana:<span className='text-bold ms-1'>{reg.semana_siembra}</span>
                                                        </div>
                                                        <div className='bw-150 text-xs me-2'>
                                                            Semillas:<span className='text-bold ms-1'>{reg.semillas.toLocaleString('en-US')}</span>
                                                        </div>
                                                        <div className='bw-200 text-xs me-2 opacity-70 text-dark'>
                                                            Usuario:<span className='text-bold ms-1'>{reg.nombre ?? 'No asignado'}</span>
                                                        </div>
                                                        <div className='bw-150 text-xs text-center bg-light shadow-sm text-bold pointer scale-025 border border-warning round-xxl'
                                                            onClick={() => switchRegistro(reg)}
                                                        >
                                                            {reg.nombre ? 'Marcar como incompleto' : 'Completar'}
                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>

                                </div>
                                <div className='w-100 mb-3' key={'divisor' + i}></div>
                            </>)
                        }
                        )}
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
            {reportePDF && <ReporteSemillaPDF
                data={reporte}
                close={() => setreportePDF(false)}
                semana_inicio={payload.semana_inicio}
                semana_fin={payload.semana_fin}
                loader={setloader}
            />}
        </div>
    )
}

export default ReporteSemilla;